export enum OPTOMIZATION_TYPE {
  hereSDK = 'HereSDKException',
  cityFlow = 'CityflowException',
}
